import { Bell, BellOff, CloudOff, MoreHorizontal, Pencil, ShoppingCart, Trash2, Wifi, X } from "lucide-react";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { AMBER, Shoppers, shoppingLine } from "./listsUi";

export function SyncStatus({ status, online, pending }) {
  if (!online) {
    return <span className="inline-flex min-h-[32px] items-center gap-1.5 rounded-full bg-q-raised px-3 text-xs font-bold text-q-muted" data-testid="offline-banner"><CloudOff className="h-3.5 w-3.5" /> Offline: changes will sync{pending ? ` (${pending})` : ""}</span>;
  }
  if (status !== "live") {
    return <span className="inline-flex min-h-[32px] items-center gap-1.5 rounded-full px-3 text-xs font-bold" style={{ background: `rgba(${AMBER},0.12)`, color: `rgb(${AMBER})` }} data-testid="live-status" data-status={status}><Wifi className="h-3.5 w-3.5 animate-pulse" /> Reconnecting…</span>;
  }
  return <span className="inline-flex min-h-[32px] items-center gap-1.5 px-1 text-xs font-semibold text-q-faint" data-testid="live-status" data-status="live"><span className="h-2 w-2 rounded-full bg-emerald-400 shadow-[0_0_8px_rgba(52,211,153,0.8)]" /> Live</span>;
}

export function ShoppingBanner({ others, store }) {
  if (!others.length) return null;
  return (
    <div className="mb-5 flex items-center gap-3 rounded-2xl border px-4 py-3 q-rise" style={{ borderColor: `rgba(${AMBER},0.45)`, background: `rgba(${AMBER},0.1)` }} data-testid="shopping-banner">
      <ShoppingCart className="h-5 w-5 flex-shrink-0" style={{ color: `rgb(${AMBER})` }} />
      <p className="min-w-0 flex-1 text-sm font-bold text-q-text" data-testid="shopping-banner-text">{shoppingLine(others, store)}</p>
      <Shoppers list={others} size={28} testid="shopping-banner-avatars" />
    </div>
  );
}

export function ListMenu({ onEdit, onDelete }) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger className="inline-flex h-11 w-11 items-center justify-center rounded-full text-q-muted outline-none hover:bg-q-raised hover:text-q-text" aria-label="List options" data-testid="list-menu-btn">
        <MoreHorizontal className="h-5 w-5" />
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="border-q-line bg-q-surface" data-testid="list-menu">
        <DropdownMenuItem onSelect={onEdit} data-testid="list-menu-edit"><Pencil className="mr-2 h-4 w-4" /> Rename list</DropdownMenuItem>
        <DropdownMenuItem onSelect={onDelete} className="text-red-300" data-testid="list-menu-delete"><Trash2 className="mr-2 h-4 w-4" /> Delete list</DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}

export function FollowButton({ following, onToggle }) {
  return (
    <button className="inline-flex min-h-[44px] items-center gap-1.5 rounded-full px-3 text-sm font-bold transition-[background-color,color] duration-200"
      style={following ? { background: `rgba(${AMBER},0.16)`, color: `rgb(${AMBER})` } : { color: "rgb(var(--q-muted))" }}
      onClick={onToggle} aria-pressed={following} data-testid="list-follow-btn" data-following={following ? "1" : "0"}>
      {following ? <Bell className="h-4 w-4" /> : <BellOff className="h-4 w-4" />} {following ? "Following" : "Follow"}
    </button>
  );
}

export function UsualChips({ usual, onAdd, onDismiss }) {
  if (!usual.length) return null;
  return (
    <div className="mb-6" data-testid="usual-items">
      <p className="mb-2 text-[10px] font-black uppercase tracking-[0.18em]" style={{ color: `rgb(${AMBER})` }}>Usual items</p>
      <div className="flex flex-wrap gap-2">
        {usual.map((u) => (
          <span key={u.name} className="inline-flex items-center rounded-full border border-q-line bg-q-surface" data-testid={`usual-chip-${u.name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>
            <button className="min-h-[44px] pl-3.5 pr-1.5 text-sm font-semibold text-q-text hover:text-white" onClick={() => onAdd(u.name)} data-testid={`usual-add-${u.name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>+ {u.name}</button>
            <button className="inline-flex h-11 w-9 items-center justify-center text-q-faint hover:text-q-text" aria-label={`Hide ${u.name}`} onClick={() => onDismiss(u.name)} data-testid={`usual-dismiss-${u.name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}><X className="h-3.5 w-3.5" /></button>
          </span>
        ))}
      </div>
    </div>
  );
}
